import { Typography } from "@material-ui/core";
import { AndroidOutlined, Apple, HelpOutline } from "@material-ui/icons";
import { format, parseISO } from "date-fns";
import { Fragment } from "react";
import { Link, useTranslate } from "react-admin";
import resourceNames from "../../../../common/data/resourceNames";
import {
  MobileApplicationType,
  SafetyDashboardDriverDto,
} from "../../../../common/data/service-proxies";
import { Widget } from "../../../assets/maintenance-dashboard/widgets/Widget";
import { DriverWidgetProps } from "../common";

const getInfoValue = (
  driver: SafetyDashboardDriverDto,
  label: string,
  value?: string
) => {
  if (!value) {
    return "-";
  }

  switch (label) {
    case "dateOfBirth":
      return format(parseISO(value), "MMM do, yyyy");
    case "mobileAppType":
      if (value === MobileApplicationType.Android) {
        return <AndroidOutlined fontSize="small" />;
      } else if (value === MobileApplicationType.AppleIos) {
        return <Apple fontSize="small" />;
      } else {
        return <HelpOutline />;
      }
    case "vehicle":
      if (!driver.vehicleId) {
        return "-";
      }

      return (
        <Link
          to={`/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/${driver.vehicleId}`}
        >
          {value}
        </Link>
      );
    default:
      return value;
  }
};

export const DriverInfoWidget = ({ driver, ...props }: DriverWidgetProps) => {
  const translate = useTranslate();
  const data = Object.getOwnPropertyNames(driver)
    .filter((x) => !x.toUpperCase().endsWith("ID"))
    .map((x) => ({ label: x, value: (driver as any)[x] }));
  return (
    <Widget {...props}>
      <div className="categories">
        <div className="info-wrapper info-wrapper-2-3">
          {data.map((x) => (
            <Fragment key={x.label}>
              <div className="info-label">
                <Typography variant="body1">
                  {translate(`resources.safety-dashboard.labels.${x.label}`)}
                </Typography>
              </div>
              <div className="info-value">
                <Typography variant="body1">
                  {getInfoValue(driver, x.label, x.value)}
                </Typography>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </Widget>
  );
};
